import { createTheme } from "@mui/material/styles";
import { color } from "framer-motion";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2", // Blue
    },
    secondary: {
      main: "#dc004e", // Red
    },
    background: {
      default: "#f4f4f4", // Light gray
    },
  },
  typography: {
    h1: {
      fontFamily: "SF Pro Display",
      fontWeight: "600",
      fontSize: "100px",
      lineHeight: "100px",
      textAlign: "center",
      letterSpacing: "1px",
      marginTop: "5rem",

      "@media(max-width:767px)": {
        fontSize: "60px !important",
        lineHeight: "60px !important",
        marginTop: "1rem",
      },
      "@media(max-width:499px)": {
        fontSize: "40px !important",
        lineHeight: "45px !important",
      },
    },
    h2: {
      fontFamily: "SF Pro Display",
      fontWeight: "700",
      fontSize: "60px",
      lineHeight: "60px",

      "@media(max-width:767px)": {
        fontSize: "28px !important",
        lineHeight: "40px !important",
      },
    },
    h3: {
      fontFamily: "SF Pro Display",
      fontWeight: "700",
      fontSize: "35px",
      lineHeight: "60px",
      color: "#000",

      "@media(max-width:767px)": {
        fontSize: "22px !important",
        lineHeight: "40px !important",
      },
    },
    h4: {
      fontFamily: "SF Pro Display",
      fontWeight: "500",
      fontSize: "20px",
      lineHeight: "34.33px",

      "@media(max-width:767px)": {
        fontSize: "18px !important",
        lineHeight: "30px !important",
      },
    },
    h5: {
      fontFamily: "SF Pro Display",
      fontWeight: "500",
      fontSize: "16px",
      lineHeight: "26px",

      "@media(max-width:767px)": {
        fontSize: "16px !important",
        lineHeight: "30px !important",
        padding: "0px 1rem",
      },
    },
    h6: {
      fontFamily: "SF Pro Display",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "26px",

      "@media(max-width:767px)": {
        fontSize: "12px !important",
        lineHeight: "20px !important",
      },
    },
    subtitle1: {
      color: "#667085",
      fontFamily: "SF Pro Display",
      fontSize: "22px",
    },
    subtitle2: {
      fontWeight: "600",
      fontFamily: "SF Pro Display",
      display: "flex",
      fontSize: "16px",
      alignItems: "center",
      cursor: "pointer",
      padding: "15px  10px",
    },
    subTitle3: {
      fontSize: "20px",
      fontFamily: "SF Pro Display",
      fontWeight: "500",
      color: "#000",
    },
    subTitle4: {
      fontSize: "22px",
      fontFamily: "SF Pro Display",
      fontWeight: "500",
    },
    subTitle5: {
      fontSize: "22px",
      fontFamily: "SF Pro Display",
      fontWeight: "500",
      "@media(max-width:767px)": {
        fontSize: "18px !important",

      },
    },
    body1: {
      fontSize: "20px",
      // fontFamily: "SF Pro Display",
      fontWeight: "700",
      "@media(max-width:767px)": {
        fontSize: "16px !important",
        lineHeight: "20px !important",
      },
    },
    body3: {
      fontSize: "16px",
      // fontFamily: "SF Pro Display",
      fontWeight: "700",
      "@media(max-width:767px)": {
        fontSize: "12px !important",
        // lineHeight: "20px !important",
      },
      "@media(max-width:375px)": {
        fontSize: "10px !important",
        // lineHeight: "20px !important",
      },
    },
    body2: {
      fontSize: "15px",
      fontFamily: "SF Pro Display",
      fontWeight: "500",
      color: "#00C381",
    },
    body3: {
      fontSize: "20px",
      fontFamily: "SF Pro Display",
      fontWeight: "500",
    },
    body4: {
      fontSize: "30px",
      fontFamily: "SF Pro Display",
      fontWeight: "500",
    },
    body5: {
      fontSize: "35px",
      fontFamily: "SF Pro Display",
      fontWeight: "600",
      "@media(max-width:767px)": {
        fontSize: "22px !important",
        // lineHeight: "20px !important",
      },
    },
    body6:{
      fontSize: "12px",
      fontFamily: "SF Pro Display",
      fontWeight: "500",
      color:"#000",
      "@media(max-width:767px)": {
        fontSize: "10px !important",
        // lineHeight: "20px !important",
      },
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px", // Rounded corners
          padding: "10px 20px",
          textTransform: "none", // Disable uppercase text
          fontWeight: "bold",
        },
        containedPrimary: {
          backgroundColor: "#2196F3",
          borderRadius: "8px",
          fontFamily: "SF Pro Display",
          fontWeight: "500",
          fontSize: "16px",
          leadingTrim: "Cap height",
          lineHeight: "21.48px",
          color: "#fff",
          "@media(max-width:767px)": {
            fontSize: "14px !important",
            padding: "6px 14px",
          },
          "@media(max-width:480px)": {
            fontSize: "12px !important",
            padding: "6px 14px",
          },
          "&:hover": {
            backgroundColor: "#2196F3",
          },
        },
        containedSecondary: {
          color: "#04BCED",
          background: "#04BCED1A !important",
          borderRadius: "8px",
          fontFamily: "SF Pro Display",
          fontWeight: "500",
          fontSize: "16px",
          leadingTrim: "Cap height",
          lineHeight: "21.48px",
          padding: "10px 16px",
          "@media(max-width:767px)": {
            fontSize: "14px !important",
            padding: "6px 14px",
          },
          "&:hover": {
            backgroundColor: "#04BCED",
            color: "#fff",
          },
        },
        outlined: {
          color: "#fff",
          background: "transparent",
          borderRadius: "80px",
          fontFamily: "SF Pro Display",
          fontWeight: "500",
          border: "1px solid #FFFFFF4D",
          fontSize: "16px",
          leadingTrim: "Cap height",
          lineHeight: "21.48px",
          padding: "4px 9px",
          "@media(max-width:767px)": {
            fontSize: "14px !important",
            padding: "6px 14px",
          },
          "&:hover": {
            backgroundColor: "#fff",
            color: "#000",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#EEEEEE", // Default border color
          },
          // "&:hover .MuiOutlinedInput-notchedOutline": {
          //   borderColor: "green", // Border color on hover
          // },

          borderRadius: "8px", // Rounded corners
          backgroundColor: "#fff", // Light background
          // backgroundColor: "#242424",
          color: "white",
          "& input::placeholder": {
            color: "gray",
            opacity: 1,
          },
        },
        "& .MuiInputLabel-root": {
          color: "rgba(255, 255, 255, 0.4)",
          top: "-6px",
        },
        input: {
          color: "#333", // Text color
          padding: "10px 14px", // Adjust padding
          "::placeholder": {
            fontFamily: "SF Pro Display",
            fontWeight: "400",
            fontSize: "12px",
            color: "#00000099",
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff",
          color: "#000",
          boxShadow: "none",
        },
      },
    },
  },
});

export default theme;
